import {
  AuthenticatedUserProfile,
  FeatureFlagKey,
  UserRedirectionData,
  UserRedirectionType,
} from '@atlassian/cssxp-typescommon';
import { useApplicationContext } from '../../common-context';

import { intersection } from 'lodash';

export function GetUserProfile() {
  const userProfile: AuthenticatedUserProfile = useApplicationContext();
  if (!userProfile) {
    return undefined;
  }
  return userProfile;
}

export function isManageAccess(key: string) {
  const userProfile = GetUserProfile();
  const permissions = userProfile?.permissions;
  return intersection(permissions, [key]).length > 0;
}

export function isWriteAccess(key: string) {
  const userProfile = GetUserProfile();
  const permissions = userProfile?.permissions;
  return intersection(permissions, [key]).length > 0;
}

export function isAccess(access: string) {
  const userProfile = GetUserProfile();
  const permissions = userProfile?.permissions;
  return intersection(permissions, [access]).length > 0;
}

export function isResourceAccess(resource: string) {
  const userProfile = GetUserProfile();
  const resources = userProfile?.resources;
  return intersection(resources, [resource]).length > 0;
}

export function isFeaturFlagAccess(flag: FeatureFlagKey) {
  const userProfile = GetUserProfile();
  if (!userProfile || !userProfile.featureFlags) {
    return false;
  }
  const featureFlag = userProfile?.featureFlags[flag];
  return featureFlag ?? false;
}

export function hasAtleastOnePermission(permissionsToCheck: string[]) {
  const userProfile = GetUserProfile();
  const permissions = userProfile?.permissions;
  return intersection(permissions, permissionsToCheck).length > 0;
}

export function hasAtleastOneRole(rolesToCheck: string[]) {
  const userProfile = GetUserProfile();
  const userRoles = userProfile?.roles;
  return intersection(userRoles, rolesToCheck).length > 0;
}

export function getAdaBaseURL(): string {
  const userProfile = GetUserProfile();
  const adaUrlObj = userProfile?.redirectionData?.find(
    (urlObj: UserRedirectionData) => urlObj.name === UserRedirectionType.ADA
  );
  return adaUrlObj?.url || '';
}

export function getCASSIBaseURL(): string {
  const userProfile = GetUserProfile();
  const adaUrlObj = userProfile?.redirectionData?.find(
    (urlObj: UserRedirectionData) => urlObj.name === UserRedirectionType.CASSI
  );
  return adaUrlObj?.url || '';
}

export function getGSACBaseURL(): string {
  const userProfile = GetUserProfile();
  const adaUrlObj = userProfile?.redirectionData?.find(
    (urlObj: UserRedirectionData) => urlObj.name === UserRedirectionType.GSAC
  );
  return adaUrlObj?.url || '';
}
